import Paginator from "component/shared/Paginator/Paginator";
import Dropdown from "component/shared/dropdown/Dropdown";
import { EXTERNAL_TRADE_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { tradeBalanceReportDisplayType } from "constants/Defaults";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import ChevronIcon from "svg-icons/chevron-icon";
import useSWR from "swr";
import { Table } from "react-bootstrap";
import { LabelLangString } from "component/LabelLang/label-lang";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { MonthName } from "functions/monthName";
import { useReactToPrint } from "react-to-print";
import ReplayIcon from "@mui/icons-material/Replay";
import numberWithCommas from "functions/numericWithCommas";
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";

const TradeBalance = ({ yearMonthDate }) => {
  const intl = useIntl();

  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const excelImage = process.env.PUBLIC_URL + "/image/Excel.svg";
  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";
  const maxDate = new Date().toJSON().slice(0, 10);
  const dir = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/external-trade",
      title: "Trade Balance External Trade Page",
    });
  }, []);

  const regionsData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.REGIONS}`,
  });

  const economicGroupsData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ECONOMIC_GROUP}`,
  });

  const defaultState = {
    TradeBalanceDisplay: null,
    displayTypeId: null,
    isTotal: null,
    FromMonth: null,
    ToMonth: null,
    FromYear: null,
    ToYear: null,
    PageSize: 10,
    CurrentPage: 1,
  };

  const [filters, setFilters] = useState(defaultState);
  const [changeState, setChangeState] = useState(defaultState);
  const [changeCount, setChangeCount] = useState(defaultState);
  const [filterCount, setFilterCount] = useState(defaultState);
  const [isTotal, setIsTotal] = useState(null);

  const handelFilterData = (e) => {
    let filterData = { ...changeState };
    if (e.target.name === "FromDate") {
      filterData["FromMonth"] = e.target.value.slice(5, 7);
      filterData["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      filterData["ToMonth"] = e.target.value.slice(5, 7);
      filterData["ToYear"] = e.target.value.slice(0, 4);
    } else {
      filterData[e.target.name] = e.target.value;
    }
    setChangeState(filterData);

    let count = { ...changeCount };
    if (e.target.name === "FromDate") {
      count["FromMonth"] = e.target.value.slice(5, 7);
      count["FromYear"] = e.target.value.slice(0, 4);
    } else if (e.target.name === "ToDate") {
      count["ToMonth"] = e.target.value.slice(5, 7);
      count["ToYear"] = e.target.value.slice(0, 4);
    } else {
      count[e.target.name] = e.target.value;
    }
    setChangeCount(count);
  };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      CurrentPage: value,
    }));
  };

  const reportFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.TRADE_BALANCE_REPORT}`,
    params: filters,
  });

  const countFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.TRADE_BALANCE_REPORT}`,
    params: filterCount,
  });

  const [tradeBalanceInfo, setTradeBalanceInfo] = useState();
  const handelChangeTradeBalanceId = (e) => {
    setTradeBalanceInfo(
      tradeBalanceReportDisplayType.find(
        (el) => +el.id === +changeState.TradeBalanceDisplay
      )
    );
  };

  const [regionInfo, setRegionInfo] = useState();
  const handelChangeDisplayTypeId = (e) => {
    setRegionInfo(
      +changeState.TradeBalanceDisplay === 2
        ? regionsData?.data?.data.find(
            (el) => +el.id === +changeState.displayTypeId
          )
        : +changeState.TradeBalanceDisplay === 3
        ? economicGroupsData?.data?.data.find(
            (el) => +el.id === +changeState.displayTypeId
          )
        : []
    );
  };

  const resetForm = () => {
    setFilters(defaultState);
    setFilterCount(defaultState);
    document.querySelectorAll("input").value = "";
    document.querySelectorAll("select").value = 0;
  };

  const elementPdf = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: `${
      dir === "rtl" ? "الميزان التجـاري" : "By trade balance"
    } - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: tradeBalanceInfo?.name,
      translations: tradeBalanceInfo?.translations,
    })} ${
      +filters.TradeBalanceDisplay === 1
        ? ""
        : // : `/ ${regionInfo?.code ?? regionInfo?.id} - ${LabelLangString({
          // `/ ${regionInfo?.code ?? regionInfo?.id} -
          ` / ${LabelLangString({
            id: "name",
            currentLocale: currentLocale,
            defaultValue: regionInfo?.name,
            translations: regionInfo?.translations,
          })}`
    } - ( ${filterCount.FromMonth}/${filterCount.FromYear} - ${
      filterCount.ToMonth
    }/${filterCount.ToYear})`,
    content: () => elementPdf.current,
    bodyClass: `${dir === "rtl" ? "exportBody-rtl" : "exportBody-ltr"}`,
  });

  // error
  const [openError, setOpenError] = useState(false);
  const handleOpenError = () => {
    setOpenError(true);
  };
  const handleCloseError = () => {
    setOpenError(false);
  };

  const [alertEmptyData, setAlertEmptyData] = useState(false);
  const handleOpenAlert = () => {
    setAlertEmptyData(true);
  };
  const handleCloseAlert = () => {
    setAlertEmptyData(false);
  };

  // Year range validation error
  const [alertYearRange, setAlertYearRange] = useState(false);
  const handleOpenYearRangeAlert = () => {
    setAlertYearRange(true);
  };
  const handleCloseYearRangeAlert = () => {
    setAlertYearRange(false);
  };

  // Function to check if date range exceeds one year
  const isDateRangeExceedsOneYear = (fromYear, fromMonth, toYear, toMonth) => {
    if (!fromYear || !fromMonth || !toYear || !toMonth) {
      return false;
    }

    const fromDate = new Date(+fromYear, +fromMonth - 1, 1);
    const toDate = new Date(+toYear, +toMonth - 1, 1);

    // Calculate difference in months
    const monthsDiff =
      (toDate.getFullYear() - fromDate.getFullYear()) * 12 +
      (toDate.getMonth() - fromDate.getMonth());

    // Check if difference is more than 12 months (1 year)
    return monthsDiff > 12;
  };

  return (
    <ContentLoading
      isLoading={regionsData.isLoading || economicGroupsData.isLoading}
    >
      <div className="active-item-news-tabs">
        <div className="browsetopic-box alls mb-0 py-3">
          <div className="container">
            <form
              className="row gy-3 align-items-center"
              onSubmit={(e) => {
                e.preventDefault();
                if (
                  (+changeState.TradeBalanceDisplay === 1 &&
                    +changeState.FromMonth &&
                    +changeState.FromYear &&
                    +changeState.ToMonth &&
                    +changeState.ToYear) ||
                  ((+changeState.TradeBalanceDisplay === 2 ||
                    +changeState.TradeBalanceDisplay === 3) &&
                    +changeState.displayTypeId &&
                    +changeState.FromMonth &&
                    +changeState.FromYear &&
                    +changeState.ToMonth &&
                    +changeState.ToYear)
                ) {
                  handleCloseAlert();
                  handleCloseYearRangeAlert();

                  // Check if date range exceeds one year
                  if (
                    isDateRangeExceedsOneYear(
                      changeState.FromYear,
                      changeState.FromMonth,
                      changeState.ToYear,
                      changeState.ToMonth
                    )
                  ) {
                    handleOpenYearRangeAlert();
                    return;
                  }

                  if (
                    new Date(
                      `${+changeState.ToYear}-${+changeState.ToMonth}`
                    ) >=
                    new Date(
                      `${+changeState.FromYear}-${+changeState.FromMonth}`
                    )
                  ) {
                    handelChangeDisplayTypeId();
                    handelChangeTradeBalanceId();
                    setFilters({ ...changeState });
                    setFilterCount({
                      ...changeCount,
                      PageSize: null,
                      CurrentPage: null,
                    });
                  } else {
                    handleOpenError();
                  }
                } else {
                  handleOpenAlert();
                }
              }}
            >
              <div className="col-12">
                <div className="item-form coll">
                  <label htmlFor="TradeBalanceDisplay">
                    <FormattedMessage id="display-type" />
                  </label>
                </div>
                <Dropdown
                  item={tradeBalanceReportDisplayType}
                  name={"TradeBalanceDisplay"}
                  placeholder={intl.formatMessage({
                    id: "choose-display-type",
                  })}
                  change={(e) => {
                    handelFilterData(e);
                    if (+e.target.value === 2 || +e.target.value === 3) {
                      setIsTotal(true);
                      setChangeState((prev) => ({ ...prev, isTotal: true }));
                      setChangeCount((prev) => ({ ...prev, isTotal: true }));
                    } else {
                      setIsTotal(null);
                      setChangeState((prev) => ({
                        ...prev,
                        displayTypeId: null,
                        isTotal: null,
                      }));
                      setChangeCount((prev) => ({
                        ...prev,
                        displayTypeId: null,
                        isTotal: null,
                      }));
                    }
                  }}
                  required={true}
                />
              </div>
              {isTotal && (
                <div className="col-12">
                  <div className="item-form coll">
                    <label htmlFor="displayTypeId">
                      <FormattedMessage id="display-type" />
                    </label>
                  </div>
                  <Dropdown
                    item={
                      +changeState.TradeBalanceDisplay === 2
                        ? regionsData?.data?.data
                        : economicGroupsData?.data?.data
                    }
                    name={"displayTypeId"}
                    placeholder={intl.formatMessage({
                      id: "choose-display-type",
                    })}
                    change={handelFilterData}
                    required={true}
                  />
                </div>
              )}
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="FromDate">
                    <FormattedMessage id="fromDate" />
                  </label>
                  <input
                    name="FromDate"
                    id="FromDate"
                    onChange={handelFilterData}
                    type="month"
                    style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                    min={`${+yearMonthDate?.importMinYear}-${
                      +yearMonthDate?.importMinMonth < 10
                        ? `0${+yearMonthDate?.importMinMonth}`
                        : +yearMonthDate?.importMinMonth
                    }`}
                    max={`${+yearMonthDate?.importMaxYear}-${
                      +yearMonthDate?.importMaxMonth < 10
                        ? `0${+yearMonthDate?.importMaxMonth}`
                        : +yearMonthDate?.importMaxMonth
                    }`}
                    className="form-control position-relative"
                    // required
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="ToDate">
                    <FormattedMessage id="toDate" />
                  </label>
                  <input
                    name="ToDate"
                    id="ToDate"
                    onChange={handelFilterData}
                    type="month"
                    style={{ textAlign: dir === "rtl" ? "end" : "start" }}
                    min={`${+yearMonthDate?.importMinYear}-${
                      +yearMonthDate?.importMinMonth < 10
                        ? `0${+yearMonthDate?.importMinMonth}`
                        : +yearMonthDate?.importMinMonth
                    }`}
                    max={`${+yearMonthDate?.importMaxYear}-${
                      +yearMonthDate?.importMaxMonth < 10
                        ? `0${+yearMonthDate?.importMaxMonth}`
                        : +yearMonthDate?.importMaxMonth
                    }`}
                    className="form-control position-relative"
                    // required
                  />
                </div>
              </div>
              <div className="col-12 col-xl-3">
                <div className="text-white fw-bold my-3">
                  <span>
                    <FormattedMessage id="allow-data" />
                  </span>
                  <span
                    className={`content h5 mb-0 fw-bold ${
                      dir === "rtl" ? "me-2" : "ms-2"
                    }`}
                    style={{ color: "var(--second-color)" }}
                  >
                    {+changeState.ReportType === 1 ||
                    +changeState.ReportType === 0
                      ? `${+yearMonthDate?.importMaxYear}-${
                          +yearMonthDate?.importMaxMonth < 10
                            ? `0${+yearMonthDate?.importMaxMonth}`
                            : +yearMonthDate?.importMaxMonth
                        }`
                      : `${+yearMonthDate?.exportMaxYear}-${
                          +yearMonthDate?.exportMaxMonth < 10
                            ? `0${+yearMonthDate?.exportMaxMonth}`
                            : +yearMonthDate?.exportMaxMonth
                        }`}
                  </span>
                </div>
              </div>
              <div className="col-12 col-xl-9">
                <div className="row align-items-center justify-content-end my-3">
                  {countFetching?.data?.data?.items &&
                    Object.keys(countFetching?.data?.data?.items).length >
                      0 && (
                      <div className="col-lg-5 col-md-6 col-12">
                        <div className="text-white fw-bold">
                          <span>
                            <FormattedMessage id="download-data" />
                          </span>
                          <span
                            className={`content ${
                              dir === "rtl" ? "me-3" : "ms-3"
                            }`}
                          >
                            <span
                              className={`sp-icon ${
                                dir === "rtl" ? "ms-3" : "me-3"
                              }`}
                              onClick={() => {
                                generateToPDF();
                              }}
                            >
                              <img
                                src={pdfImage}
                                style={{
                                  width: "40px",
                                  cursor: "pointer",
                                  borderRadius: "6px",
                                }}
                                alt="pdf-image"
                              />
                            </span>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className={`border-0 bg-transparent`}
                              table={`table-to-xls-trade-balance-report`}
                              filename={`${
                                dir === "rtl"
                                  ? "الميزان التجـاري"
                                  : "By trade balance"
                              } - ${LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: tradeBalanceInfo?.name,
                                translations: tradeBalanceInfo?.translations,
                              })} ${
                                +filters.TradeBalanceDisplay === 1
                                  ? ""
                                  : `/ 
                                     ${LabelLangString({
                                       id: "name",
                                       currentLocale: currentLocale,
                                       defaultValue: regionInfo?.name,
                                       translations: regionInfo?.translations,
                                     })}`
                              } - ( ${filterCount.FromMonth}/${
                                filterCount.FromYear
                              } - ${filterCount.ToMonth}/${
                                filterCount.ToYear
                              })`}
                              sheet="tablexls"
                              buttonText={
                                <span className="sp-icon">
                                  <img
                                    src={excelImage}
                                    style={{
                                      width: "40px",
                                      cursor: "pointer",
                                      borderRadius: "6px",
                                    }}
                                    alt="excel-image"
                                  />
                                </span>
                              }
                            />
                          </span>
                        </div>
                      </div>
                    )}
                  <div className="col-lg-7 col-md-6 col-12">
                    <div className="d-flex gap-2 mt-3 mt-md-0">
                      <button type="submit" className="main-btn">
                        <span>
                          <FormattedMessage id="view-data" />
                        </span>
                        <ChevronIcon width={12} height={12} />
                      </button>
                      <button
                        type="reset"
                        className="second-btn"
                        onClick={() => {
                          resetForm();
                        }}
                      >
                        <span>
                          <FormattedMessage id="reset" />
                        </span>
                        <ReplayIcon style={{ fontSize: 20 }} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* error */}
        <SnackbarModal
          open={openError}
          onClose={handleCloseError}
          severity="error"
          message={intl.formatMessage({
            id: "fromDate_ToDate_Role",
          })}
        />

        <SnackbarModal
          open={alertEmptyData}
          onClose={handleCloseAlert}
          severity="error"
          message={intl.formatMessage({
            id: "must_fill_all_fields",
          })}
        />

        <SnackbarModal
          open={alertYearRange}
          onClose={handleCloseYearRangeAlert}
          severity="error"
          message={intl.formatMessage({
            id: "date_range_exceeds_one_year",
          })}
        />

        <div className="body-news pt-4">
          {reportFetching?.isLoading ? (
            <h5 className="text-center" dir="ltr">
              <FormattedMessage id="loading..." />
            </h5>
          ) : reportFetching?.data?.data?.items ? (
            Object.keys(reportFetching?.data?.data?.items).length > 0 ? (
              <>
                <Table
                  responsive
                  striped
                  bordered
                  hover
                  className="text-center"
                >
                  <thead className="text-white main-bg">
                    <tr>
                      <th colSpan={filters.isTotal ? 10 : 6}>
                        {LabelLangString({
                          id: "name",
                          currentLocale: currentLocale,
                          defaultValue: tradeBalanceInfo?.name,
                          translations: tradeBalanceInfo?.translations,
                        })}{" "}
                        {/* -{" "}{dir === "rtl"
                          ? "الميزان التجـاري"
                          : "By trade balance"
                        }{" "} */}
                        -- ( <FormattedMessage id="period-from" />{" "}
                        {`${filters.FromMonth}/${filters.FromYear}`} -{" "}
                        <FormattedMessage id="to" />{" "}
                        {`${filters.ToMonth}/${filters.ToYear}`} )
                      </th>
                    </tr>
                    {filters.isTotal && (
                      <tr>
                        <th colSpan={10}>
                          {/* {regionInfo?.code ?? regionInfo?.id} -{" "} */}
                          {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: regionInfo?.name,
                            translations: regionInfo?.translations,
                          })}
                        </th>
                      </tr>
                    )}
                    <tr>
                      <th colSpan={filters.isTotal ? 10 : 6}>
                        {intl.formatMessage({
                          id: "quantity-data-under-constraction",
                        })}
                      </th>
                    </tr>
                    <tr>
                      <th style={{ width: "15%" }}>
                        {intl.formatMessage({
                          id: `${filters.isTotal ? "code" : "the-month"}`,
                        })}
                      </th>
                      {filters.isTotal && (
                        <th>{intl.formatMessage({ id: "region" })}</th>
                      )}
                      <th>
                        {intl.formatMessage({ id: "pound-export-value" })}
                      </th>
                      <th>
                        {intl.formatMessage({ id: "dollar-export-value" })}
                      </th>
                      <th>
                        {intl.formatMessage({ id: "pound-import-value" })}
                      </th>
                      <th>
                        {intl.formatMessage({ id: "dollar-import-value" })}
                      </th>
                      {!filters.isTotal && (
                        <th>{intl.formatMessage({ id: "coverage" })} %</th>
                      )}
                      {filters.isTotal && (
                        <>
                          <th>
                            {intl.formatMessage({ id: "net-balance-pound" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "net-balance-dollar" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "trade-exchange-pound" })}
                          </th>
                          <th>
                            {intl.formatMessage({
                              id: "trade-exchange-dollar",
                            })}
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {!filters.isTotal && (
                      <tr>
                        <td>{intl.formatMessage({ id: "totaly" })}</td>
                        <td>
                          {numberWithCommas(
                            countFetching?.data?.data?.totals?.totalExportsEGP?.toFixed(
                              2
                            )
                          )}
                        </td>
                        <td>
                          {numberWithCommas(
                            countFetching?.data?.data?.totals?.totalExportsUSD?.toFixed(
                              2
                            )
                          )}
                        </td>
                        <td>
                          {numberWithCommas(
                            countFetching?.data?.data?.totals?.totalImportsEGP?.toFixed(
                              2
                            )
                          )}
                        </td>
                        <td>
                          {numberWithCommas(
                            countFetching?.data?.data?.totals?.totalImportsUSD?.toFixed(
                              2
                            )
                          )}
                        </td>
                        <td>
                          {numberWithCommas(
                            (
                              (countFetching?.data?.data?.totals
                                ?.totalExportsEGP /
                                countFetching?.data?.data?.totals
                                  ?.totalImportsEGP) *
                              100
                            )?.toFixed(2)
                          )}
                        </td>
                      </tr>
                    )}
                    <Paginator
                      size={filters.PageSize}
                      table={true}
                      colspan={filters.isTotal ? 10 : 6}
                      change={onPageIndexChange}
                      page={filters.CurrentPage}
                      totalCount={reportFetching?.data?.data?.pager?.totalCount}
                    >
                      {reportFetching?.data?.data?.items.map(
                        (
                          {
                            month,
                            year,
                            region,
                            translation,
                            description,
                            code,
                            importsValueEGP,
                            importsValueUSD,
                            exportsValueEGP,
                            exportsValueUSD,
                          },
                          i
                        ) => (
                          <tr key={i}>
                            <td>
                              {/* {code ?? <MonthName month={month} year={year} />} */}
                              {code ?? `${month}/${year}`}
                            </td>
                            {filters.isTotal && (
                              <td>
                                {region
                                  ? LabelLangString({
                                      id: "name",
                                      currentLocale: currentLocale,
                                      defaultValue: region,
                                      translations: translation,
                                    })
                                  : description}
                              </td>
                            )}
                            <td>
                              {numberWithCommas(exportsValueEGP?.toFixed(2))}
                            </td>
                            <td>
                              {numberWithCommas(exportsValueUSD?.toFixed(2))}
                            </td>
                            <td>
                              {numberWithCommas(importsValueEGP?.toFixed(2))}
                            </td>
                            <td>
                              {numberWithCommas(importsValueUSD?.toFixed(2))}
                            </td>
                            {!filters.isTotal && (
                              <td>
                                {numberWithCommas(
                                  (
                                    (exportsValueEGP / importsValueEGP) *
                                    100
                                  )?.toFixed(2)
                                )}
                              </td>
                            )}
                            {filters.isTotal && (
                              <>
                                <td>
                                  {numberWithCommas(
                                    (
                                      exportsValueEGP - importsValueEGP
                                    )?.toFixed(2)
                                  )}
                                </td>
                                <td>
                                  {numberWithCommas(
                                    (
                                      exportsValueUSD - importsValueUSD
                                    )?.toFixed(2)
                                  )}
                                </td>
                                <td>
                                  {numberWithCommas(
                                    (
                                      exportsValueEGP + importsValueEGP
                                    )?.toFixed(2)
                                  )}
                                </td>
                                <td>
                                  {numberWithCommas(
                                    (
                                      exportsValueUSD + importsValueUSD
                                    )?.toFixed(2)
                                  )}
                                </td>
                              </>
                            )}
                          </tr>
                        )
                      )}
                    </Paginator>
                  </tbody>
                </Table>

                <div className="d-none">
                  <div ref={elementPdf}>
                    <img
                      src={pdfHeader}
                      alt="pdf-header"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        top: "5px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                    <Table
                      responsive
                      striped
                      bordered
                      hover
                      className="text-center"
                      id={`table-to-xls-trade-balance-report`}
                    >
                      <thead className="text-white main-bg">
                        <tr>
                          <th colSpan={filterCount.isTotal ? 10 : 6}>
                            {maxDate}
                          </th>
                        </tr>
                        <tr>
                          <th colSpan={filterCount.isTotal ? 10 : 6}>
                            {LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: tradeBalanceInfo?.name,
                              translations: tradeBalanceInfo?.translations,
                            })}{" "}
                            {/* -{" "}{dir === "rtl"
                              ? "الميزان التجـاري"
                              : "By trade balance"
                            }{" "} */}
                            -- ( <FormattedMessage id="period-from" />{" "}
                            {`${filterCount.FromMonth}/${filterCount.FromYear}`}{" "}
                            - <FormattedMessage id="to" />{" "}
                            {`${filterCount.ToMonth}/${filterCount.ToYear}`} )
                          </th>
                        </tr>
                        {filterCount.isTotal && (
                          <tr>
                            <th colSpan={10}>
                              {/* {regionInfo?.code ?? regionInfo?.id} -{" "} */}
                              {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: regionInfo?.name,
                                translations: regionInfo?.translations,
                              })}
                            </th>
                          </tr>
                        )}
                        <tr>
                          <th colSpan={filterCount.isTotal ? 10 : 6}>
                            {intl.formatMessage({
                              id: "quantity-data-under-constraction",
                            })}
                          </th>
                        </tr>
                        <tr>
                          <th style={{ width: "15%" }}>
                            {intl.formatMessage({
                              id: `${
                                filterCount.isTotal ? "code" : "the-month"
                              }`,
                            })}
                          </th>
                          {filterCount.isTotal && (
                            <th>{intl.formatMessage({ id: "region" })}</th>
                          )}
                          <th>
                            {intl.formatMessage({ id: "pound-export-value" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "dollar-export-value" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "pound-import-value" })}
                          </th>
                          <th>
                            {intl.formatMessage({ id: "dollar-import-value" })}
                          </th>
                          {!filterCount.isTotal && (
                            <th>{intl.formatMessage({ id: "coverage" })} %</th>
                          )}
                          {filterCount.isTotal && (
                            <>
                              <th>
                                {intl.formatMessage({
                                  id: "net-balance-pound",
                                })}
                              </th>
                              <th>
                                {intl.formatMessage({
                                  id: "net-balance-dollar",
                                })}
                              </th>
                              <th>
                                {intl.formatMessage({
                                  id: "trade-exchange-pound",
                                })}
                              </th>
                              <th>
                                {intl.formatMessage({
                                  id: "trade-exchange-dollar",
                                })}
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {!filterCount.isTotal && (
                          <tr>
                            <td>{intl.formatMessage({ id: "totaly" })}</td>
                            <td>
                              {numberWithCommas(
                                countFetching?.data?.data?.totals?.totalExportsEGP?.toFixed(
                                  2
                                )
                              )}
                            </td>
                            <td>
                              {numberWithCommas(
                                countFetching?.data?.data?.totals?.totalExportsUSD?.toFixed(
                                  2
                                )
                              )}
                            </td>
                            <td>
                              {numberWithCommas(
                                countFetching?.data?.data?.totals?.totalImportsEGP?.toFixed(
                                  2
                                )
                              )}
                            </td>
                            <td>
                              {numberWithCommas(
                                countFetching?.data?.data?.totals?.totalImportsUSD?.toFixed(
                                  2
                                )
                              )}
                            </td>
                            <td>
                              {numberWithCommas(
                                (
                                  (countFetching?.data?.data?.totals
                                    ?.totalExportsEGP /
                                    countFetching?.data?.data?.totals
                                      ?.totalImportsEGP) *
                                  100
                                )?.toFixed(2)
                              )}
                            </td>
                          </tr>
                        )}
                        {countFetching?.data?.data?.items.map(
                          (
                            {
                              month,
                              year,
                              region,
                              translation,
                              description,
                              code,
                              importsValueEGP,
                              importsValueUSD,
                              exportsValueEGP,
                              exportsValueUSD,
                            },
                            i
                          ) => (
                            <tr key={i}>
                              <td>
                                {/* {code ?? <MonthName month={month} year={year} />} */}
                                {code ?? `${month}/${year}`}
                              </td>
                              {filterCount.isTotal && (
                                <td>
                                  {region
                                    ? LabelLangString({
                                        id: "name",
                                        currentLocale: currentLocale,
                                        defaultValue: region,
                                        translations: translation,
                                      })
                                    : description}
                                </td>
                              )}
                              <td>
                                {numberWithCommas(exportsValueEGP?.toFixed(2))}
                              </td>
                              <td>
                                {numberWithCommas(exportsValueUSD?.toFixed(2))}
                              </td>
                              <td>
                                {numberWithCommas(importsValueEGP?.toFixed(2))}
                              </td>
                              <td>
                                {numberWithCommas(importsValueUSD?.toFixed(2))}
                              </td>
                              {!filterCount.isTotal && (
                                <td>
                                  {numberWithCommas(
                                    (
                                      (exportsValueEGP / importsValueEGP) *
                                      100
                                    )?.toFixed(2)
                                  )}
                                </td>
                              )}
                              {filterCount.isTotal && (
                                <>
                                  <td>
                                    {numberWithCommas(
                                      (
                                        exportsValueEGP - importsValueEGP
                                      )?.toFixed(2)
                                    )}
                                  </td>
                                  <td>
                                    {numberWithCommas(
                                      (
                                        exportsValueUSD - importsValueUSD
                                      )?.toFixed(2)
                                    )}
                                  </td>
                                  <td>
                                    {numberWithCommas(
                                      (
                                        exportsValueEGP + importsValueEGP
                                      )?.toFixed(2)
                                    )}
                                  </td>
                                  <td>
                                    {numberWithCommas(
                                      (
                                        exportsValueUSD + importsValueUSD
                                      )?.toFixed(2)
                                    )}
                                  </td>
                                </>
                              )}
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                    <img
                      src={pdfFooter}
                      alt="pdf-footer"
                      className="w-100"
                      style={{
                        // position: "fixed",
                        bottom: "10px",
                        left: 1,
                        zIndex: 100000,
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <h4 className="text-center">
                <FormattedMessage id="data-not-found" />
              </h4>
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </ContentLoading>
  );
};

export default TradeBalance;
